import { render, staticRenderFns } from "./CLightswitch.vue?vue&type=template&id=2d4d1c20"
import script from "./CLightswitch.vue?vue&type=script&lang=js"
export * from "./CLightswitch.vue?vue&type=script&lang=js"
import style0 from "./CLightswitch.vue?vue&type=style&index=0&id=2d4d1c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports